/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { ExtensibleNode } from '../../core/models/ExtensibleNode';
import { Extension } from '../../core/models/Extension';
import { NodePath } from '../../core/models/NodePath';
import { Node } from '../../core/models/Node';

/**
 * A command used to create a new tag.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class NewExtensionCommand extends AbstractCommand {
    public _parentPath : NodePath;

    public _name : string;

    public _value : any;

    public _created : boolean;

    public constructor(parent? : any, name? : any, value? : any) {
        if(((parent != null && parent instanceof <any>ExtensibleNode) || parent === null) && ((typeof name === 'string') || name === null) && ((value != null) || value === null)) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._name===undefined) this._name = null;
            if(this._value===undefined) this._value = null;
            if(this._created===undefined) this._created = false;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._name===undefined) this._name = null;
            if(this._value===undefined) this._value = null;
            if(this._created===undefined) this._created = false;
            (() => {
                this._parentPath = Library.createNodePath(parent);
                this._name = name;
                this._value = value;
            })();
        } else if(parent === undefined && name === undefined && value === undefined) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._name===undefined) this._name = null;
            if(this._value===undefined) this._value = null;
            if(this._created===undefined) this._created = false;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._name===undefined) this._name = null;
            if(this._value===undefined) this._value = null;
            if(this._created===undefined) this._created = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[NewExtensionCommand] Executing.");
        this._created = false;
        let parent : ExtensibleNode = <ExtensibleNode>this._parentPath.resolve(document);
        let extension : Extension = parent.getExtension(this._name);
        if(!this.isNullOrUndefined(extension)) {
            return;
        }
        extension = parent.createExtension();
        extension.name = this._name;
        extension.value = this._value;
        parent.addExtension(this._name, extension);
        this._created = true;
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[NewExtensionCommand] Reverting.");
        if(!this._created) {
            return;
        }
        let parent : ExtensibleNode = <ExtensibleNode>this._parentPath.resolve(document);
        if(!this._created) {
            return;
        }
        parent.removeExtension(this._name);
    }
}
NewExtensionCommand["__class"] = "io.apicurio.datamodels.cmd.commands.NewExtensionCommand";
NewExtensionCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




